export const formatCurrency = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined) {
    return "";
  }

  const numericValue = typeof value === "string" ? Number.parseFloat(value) : value;
  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    minimumFractionDigits: 0,
  }).format(numericValue);
};
